// removed by extract-text-webpack-plugin
module.exports = {"container":"_18jADTmEsZVk-Rtthf3iGn","icon":"nn9ktQSyA6jrpU0UlXdP-","title":"_2uPtWWxodVJOSKZFygGWFM","Email":"_2-Qfu_B2Z6tzF7RDvYIdYK","Signer":"_26EnzaWOYv2Ck3_iDvL0tN","Subraya":"_2O5g2bT5Hibjk4Yr071f8p"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/FeaSigners/styles.css
// module id = 2847
// module chunks = 0